export const pendingApprovalSharedDesignsApiPageSelector = (state, page) => {
  return state.api.designs.personal.approvals.pendingApprovalShared.pages[page];
};

export const pendingApprovalSharedDesignsApiSelector = (state, page) => {
  return state.api.designs.personal.approvals.pendingApprovalShared;
};
